// eslint-disable-next-line import/prefer-default-export
import api from "@/api/api.js";
import store from "@/store"
import webconf from "../../../utils/frontend_setup";
import backend from "@/api/backend";

export const installationsActions = {
  pushInstallation: async ({ commit }, installation = { key: null, hide: false, type: "success", message: "Enregistrement effectué avec succès." }) => {
    installation.key = Date.now()
    installation.hide = false
    commit('PUSH_INSTALLATION', installation)

    setTimeout(() => {
      commit('HIDE_INSTALLATION', installation.key)
    }, 2000)

    setTimeout(() => {
      commit('REMOVE_INSTALLATION', installation.key)
    }, 4000)
  },

  // getInstallations: async ({ rootState, commit }, data = {
  //   id_ref_site: null, distance: null
  // }) => {
  //   return api
  //     .getInstallations({
  //       'start_date': store.state.parametersStore.dates.start,
  //       'end_date': store.state.parametersStore.dates.end,
  //       'installation_id': data?.id_ref_site,
  //     }).then((res) => {
  //       const role = rootState.authStore.role
  //       const roles = ['user', 'data-analyst', 'admin']
  //       const roleIndex = roles.indexOf(role)
  //       const statusRoles = {
  //         "Vérifications préliminaires": 1,
  //         "Analyse en cours": 1,
  //         "Analyse disponible": 0,
  //         "Analyse bientôt indisponible": 0,
  //         "Analyse indisponible": 0,
  //       }
  //
  //       let installations = res.data.map(i => {
  //         return {
  //           ...i,
  //           ... {
  //             id: i.installation_id,
  //             is_forbidden: (statusRoles[i.status] > roleIndex || (i.status.length === 0 && roleIndex < 1))
  //           }
  //         }
  //       })
  //
  //       if (data && data.id_ref_site) {
  //         installations = installations.filter(installation => installation.dist_ref <= data.distance)
  //         commit('SET_IS_FILTRED_BY_GEO', true)
  //       }
  //       else commit('SET_IS_FILTRED_BY_GEO', false)
  //
  //       commit('SET_INSTALLATIONS', installations)
  //     });
  // },

  getInstallationList: async ({ rootState, commit }, data = { analysis_mode: undefined }) => {
    return api
      .getInstallationList().then(async (res) => {
        const role = rootState.authStore.role
        const roles = ['user', 'data-analyst', 'admin']
        const roleIndex = roles.indexOf(role)
        const statusRoles = {
          // "Aucune donnée": 1,
          "Vérifications préliminaires": 1,
          "Analyse en cours": 1,
          "Analyse disponible": 0,
          "Analyse bientôt indisponible": 0,
          "Analyse indisponible": 0,
        }

        let result = res.data
        if (data?.type !== undefined) {
          result = result.filter((install) => install.type === data?.type)
        }
        try {
          await backend.get_installs().then((resultat) => {
          
          const nouvInstallations = resultat.data
          for (const index in nouvInstallations) {
            const aParser = nouvInstallations[index]
            if (aParser.description !== null) {
              const installation = {}
              installation['address'] = aParser.description.adresse + ', ' + aParser.description.codePostal + ' ' + aParser.description.ville
              installation['audit_start_date'] = aParser.description.dateDebut
              installation['audit_end_date'] = aParser.description.dateFin
              installation['city'] = aParser.description.ville
              installation['company_name'] = aParser.description.societe
              installation['installation_id'] = aParser.id
              installation['installation_name'] = aParser.description.nom
              let orientations = ""
              for (const rampantIndex in aParser.rampants_inventory) {
                const rampant = aParser.rampants_inventory[rampantIndex]
                orientations = orientations + rampant.orientationPV + '°/' + rampant.inclinaisonPV + '°, '
              }
              orientations = orientations.slice(0, -2)
              installation['installation_type'] = aParser.rampants_inventory[0].installationChoisie + '- ' + orientations
              installation['installed_power_kwc'] = aParser.description.pInstallee
              installation['inv_count'] = aParser.history.length
              installation['latitude'] = aParser.description.markerLatLng0
              installation['longitude'] = aParser.description.markerLatLng1
              installation['mpp_count'] = aParser.layouts.length
              installation['plane'] = aParser.rampants_inventory.length
              installation['status'] = "Analyse à faire"
              installation['techno_inv_list'] = []
              for (const invIndex in aParser.inverters_inventory) {
                installation['techno_inv_list'].push(aParser.inverters_inventory[invIndex].modele)
              }
              installation['tehno_module_list'] = []
              for (const moduleIndex in aParser.modules_inventory) {
                installation['tehno_module_list'].push(aParser.modules_inventory[moduleIndex].modele)
              }
              installation['tz_grid'] = aParser.description.utcProd
              installation['tz_in_situ'] = aParser.description.utcMeteoInSitu
              installation['tz_meteo'] = aParser.description.utcMeteo
              installation['tz_pv'] = aParser.description.utcData
              installation['pdf_link'] = ""
              installation['installed_power_kwc'] = aParser.description.pInstallee / 1000

              result.push(installation)
            }
          }
        }
      )
        }
        catch{
          console.error("Aucun audit a ajouter")
        }
        

      

    let installations = result.map(i => {
      return {
        ...i,
        ... {
          id: i.installation_id,
          is_forbidden: (statusRoles[i.status] > roleIndex || (i.status.length === 0 && roleIndex < 1))
        }
      }
    }).sort((i1, i2) =>
      (i1.installation_name.toLowerCase() < i2.installation_name.toLowerCase())
        ? -1
        : (i1.installation_name.toLowerCase() > i2.installation_name.toLowerCase())
          ? 1
          : 0
    )

    webconf.debugLog('api', './store/modules/Installations/actions.js',
      `getInstallationList`,
      installations
    )
    commit('SET_INSTALLATIONS', installations)
  });
  },

getInstallation: async ({ commit }, data = {
  id_ref_site: 0
}) => {
  return api
    .getInstallations({
      'start_date': store.state.parametersStore.dates.start,
      'end_date': store.state.parametersStore.dates.end,
      'installation_id': data.id_ref_site,
    }
    )
    .then((res) => {
      webconf.debugLog('api', './store/modules/Installations/actions.js',
        `getInstallation`,
        res.data ? res.data[0] : {}
      )

      commit('UPDATE_INSTALLATION', {
        installation_id: data?.id_ref_site,
        install: res.data ? res.data[0] : {}
      })
    });
},

  getInstallationLoss: async ({ commit }, data = {
    id_ref_site: null,
    start: String,
    end: String
  }) => {
    return api
      .getInstallationLoss({
        // 'start_date': store.state.parametersStore.dates.start,
        // 'end_date': store.state.parametersStore.dates.end,
        'start_date': data.start,
        'end_date': data.end,
        'installation_id': data?.id_ref_site,
      }
      )
      .then((res) => {
        webconf.debugLog('api', './store/modules/Installations/actions.js',
          `getInstallationLoss`,
          res.data ? res.data[0] : {}
        )

        commit('SET_INSTALLATION_LOSS', {
          installation_id: data?.id_ref_site,
          loss: res.data ? res.data[0] : {}
        })
      });
  },

  // getInstallationSubarray: async ({ commit }, data = {
  //   id_ref_site: null,
  //   start: String,
  //   end: String
  // }) => {
  //   return api
  //     .getInstallationSubarray({
  //       // 'start_date': store.state.parametersStore.dates.start,
  //       // 'end_date': store.state.parametersStore.dates.end,
  //       'start_date': data.start,
  //       'end_date': data.end,
  //       'installation_id': data?.id_ref_site,
  //     }
  //     )
  //     .then((res) => {
  //       webconf.debugLog('api', './store/modules/Installations/actions.js',
  //           `getInstallationSubarray`,
  //           res.data ? res.data[0] : {}
  //       )
  //
  //       commit('SET_INSTALLATION_SUBARRAY', {
  //         installation_id: data?.id_ref_site,
  //         subarray: res.data[0]
  //       })
  //     });
  // },
};
